module.exports = __webpack_public_path__ + "img/C-pic-01.7e4d3e42.png";